import { Star } from "lucide-react";

const ITEMS = [
    "DAUR ULANG KERTAS",
    "YOUTH ECO CRAFTS",
    "UBAH SAMPAH KERTAS JADI KARYA",
    "SUPPORT LOCAL CREATORS",
    "KONSULTASI VIA WHATSAPP 0813-8319-664",
    "ACTURE.ID",
];

export default function Marquee() {
    return (
        <section aria-hidden="true" className="relative py-8 overflow-hidden">
            <div className="-rotate-1 scale-[1.03] bg-brand-forest border-y-2 border-brand-ink py-3.5 overflow-hidden shadow-hard-sm">
                <div className="flex w-max animate-marquee">
                    {[...ITEMS, ...ITEMS].map((t, i) => (
                        <span
                            key={i}
                            className="flex items-center gap-8 px-8 font-display text-sm font-bold tracking-[0.22em] text-brand-sunshine whitespace-nowrap"
                        >
                            {t}
                            <Star className="w-4 h-4 fill-brand-sunshine text-brand-sunshine shrink-0" />
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
